import axios from "axios";
import { resolveTarget } from "@/lib/targetKeyword";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "triaxis_session_id";
const FIRST_TOUCH_KEY = "triaxis_first_touch";

const safeStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

function sessionId() {
  const store = safeStorage();
  let id = store?.getItem(SESSION_KEY);
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    store?.setItem(SESSION_KEY, id);
  }
  return id;
}

function externalReferrer() {
  if (!document.referrer) return "";
  try {
    return new URL(document.referrer).host === window.location.host ? "" : document.referrer;
  } catch {
    return "";
  }
}

/** Record one page view; the first view of a browser session is the landing view. */
export function trackPageView(pathname, search) {
  if (pathname.startsWith("/admin")) return;
  const store = safeStorage();
  const landing = !store?.getItem(FIRST_TOUCH_KEY);
  const { keyword, page_type } = resolveTarget(pathname);
  const params = new URLSearchParams(search);
  const referrer = landing ? externalReferrer() : "";
  if (landing) {
    store?.setItem(
      FIRST_TOUCH_KEY,
      JSON.stringify({ landing_path: pathname, landing_keyword: keyword, traffic_source: params.get("utm_source") || (referrer ? new URL(referrer).host : "direct") })
    );
  }
  axios
    .post(`${API}/track`, {
      path: pathname,
      keyword,
      page_type,
      referrer,
      session_id: sessionId(),
      landing,
      utm_source: params.get("utm_source") || undefined,
      utm_medium: params.get("utm_medium") || undefined,
      utm_campaign: params.get("utm_campaign") || undefined,
      utm_term: params.get("utm_term") || undefined,
    })
    .catch(() => {});
}

/** Blog posts resolve their keyword after load; patch first-touch so leads attribute correctly. */
export function setLandingKeyword(pathname, keyword) {
  const store = safeStorage();
  const raw = store?.getItem(FIRST_TOUCH_KEY);
  if (!raw || !keyword) return;
  const ft = JSON.parse(raw);
  if (ft.landing_path === pathname && !ft.landing_keyword) {
    store.setItem(FIRST_TOUCH_KEY, JSON.stringify({ ...ft, landing_keyword: keyword }));
  }
}

/** Merge first-touch attribution into a lead payload. */
export function withAttribution(payload) {
  try {
    const ft = JSON.parse(safeStorage()?.getItem(FIRST_TOUCH_KEY) || "{}");
    return { ...payload, landing_path: ft.landing_path, landing_keyword: ft.landing_keyword || undefined, traffic_source: ft.traffic_source };
  } catch {
    return payload;
  }
}
